// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"76":"common","165":"vditor","760":"ai-chat"}[chunkId] || chunkId) + "." + {"76":"5485d160","165":"a8a25139","258":"b35ee4f3","259":"c6186ef5","311":"272bcbf6","677":"3457745c","756":"b890e7bf","760":"3ee4efd9","866":"93510891"}[chunkId] + ".js";
};